import React, { Component } from "react";

import { Element } from "react-scroll";

import "./restaurantes.css";

import axios from "axios";

import Restaurante from "./Restaurante";

import PropTypes from "prop-types";

export default class NewRestaurantes extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      restaurantes: [],
    };
  }

  componentDidMount = () => {
    this.loadRestaurantes();
  };

  loadRestaurantes = async () => {
    let res = {};
    try {
      res = await axios.get("/api/restaurantes", {
        params: {},
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.log(error);
    }

    let restaurantes = res.data.arrayRestaurantes;

    this.setState({ restaurantes });
  };

  restauranteClicked = (identifier) => {
    this.context.router.history.push("/restaurantes/" + identifier);
  }

  render() {
    const items = this.state.restaurantes.map(function (item) {
      return (
        <div onClick={() => this.restauranteClicked(item.identifier)} className="box-shadow restaurante-small">
          <p className="title">{item.name}</p>
          <p className="subtitle">{item.type}</p>
        </div>
      )
    }, this);
    return (
      <section id="restaurantes">
        <Element name="restaurantesElement" />
        <div className="container">

            <div className="title-container">
              <h2>Restaurantes</h2>
              <p>Prove os pratos tradicionais da nossa aldeia!</p>
            </div>
            
            <div className="content-container">
              {items.length === 0 ? <><p style={{width: '100%'}}>De momento não encontramos os cozinheiros e cozinheiras da aldeia.</p><p>Venha ajudar-nos a procurar nas ruas da aldeia.</p></> : items }
            </div>
          
        </div>
      </section>
    );
  }
}
